import { environment } from 'src/environments/environment';

export const UserType = {
  USER: 'APP.PDP.' + environment.id.toUpperCase() + '.USER',
  ADMIN: 'APP.PDP.' + environment.id.toUpperCase() + '.ADMIN'
}